<template>
	<c-dialog ref="dialog" title="设置中标企业" width="750" height="600" button-name="确认并提交" @resolve="submitHandle">
		<c-form ref="form" unit-width="400">
			<c-form-item type="hidden" name="project_id"></c-form-item>
			<c-form-item type="select" label="中标企业" name="zbqy_id" options="COMPANY_LIST" required search></c-form-item>
			<c-form-item type="number" decimal="2" label="中标金额" name="zb_money" required input-word="元"></c-form-item>
			<c-form-item type="file" label="中标通知书" name="zb_path" required file-type="word,pdf,zip,image"></c-form-item>
			<c-form-item label="需购买保函" name="bx_type_ids" required>
				<c-checkbox-group v-model="currentInsurance">
					<c-checkbox v-for="(item, i) in insuranceType" :key="i" :value="item.value">{{item.name}}</c-checkbox>
				</c-checkbox-group>
			</c-form-item>
			<c-form-item type="input" label="被保险人" name="bbxr_name" required></c-form-item>
			<c-form-item type="input" label="被保险人组织代码" name="bbxr_jgdm" required></c-form-item>
			<c-form-item type="datetime" label="签约截止日" name="qy_last_date" required></c-form-item>
			<c-form-item type="number" label="工期" name="sggq" input-word="天" required></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="zb_remark"></c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				insuranceType: [],
				currentInsurance: []
			}
		},
		
		mounted() {
			this.request({
				url: '/bx_type/list',
				success: data => {
					this.insuranceType = Array.from(data, item => {
						return {
							name: item.type_name,
							value: item.type_id
						}
					});
				}
			});
		},
		
		methods: {
			open(id) {
				this.$refs.form.clear();
				this.$refs.form.set({
					project_id: id
				});
				this.request({
					url: '/project/detail',
					data: {
						project_id: id
					},
					success: data => {
						this.$refs.form.set({
							bbxr_name: data.project_info.yzdw_name,
							bbxr_jgdm: data.project_info.yzdw_yyzzh
						});
					}
				});
				this.currentInsurance = Array.from(this.insuranceType, item => item.value);
				this.$refs.dialog.open();
			},
			
			submitHandle(stop, next) {
				stop();
				
				this.$refs.form.submit({
					url: '/project/set_zbqy',
					rule: {
						zbqy_id: '请选择中标企业',
						zb_money: '请填写中标金额',
						zb_path: '请上传中标通知书',
						bbxr_name: '请填写被保险人',
						bbxr_jgdm: '请填写被保险人组织代码',
						qy_last_date: '请选择签约截止日',
						sggq: '请填写工期'
					},
					dataFormatter: data => {
						data.bx_type_ids = this.currentInsurance;
						return data;
					},
					success: () => {
						next();
						this.$message({
							text: '提交成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>